// extracted by mini-css-extract-plugin
export default {"usersimage":"Products_usersimage__+hGHY","add":"Products_add__kziF3","update":"Products_update__MUuXk","form":"Products_form__Hiol-","userno":"Products_userno__SIygV"};